import numberToCurrency from '@/utilities/numberFormatter';
import replaceAbbreviations from '@/utilities/replaceAbbreviations';

export const SummaryPrice = ({
  title,
  subtitle,
  price,
}: {
  title: string;
  subtitle: string;
  price: number | null;
}) => {
  if (!price) return;
  return (
    <div className="SummaryPrice">
      <div className="SummaryPrice__col">
        <div className="SummaryPrice__title">{title}</div>
        <div
          className="SummaryPrice__subtitle"
          dangerouslySetInnerHTML={replaceAbbreviations(subtitle)}
        />
      </div>
      <div className="SummaryPrice__col">
        <div className="SummaryPrice__price">{numberToCurrency(price)}</div>
      </div>
    </div>
  );
};
